import WeekBlock from "./WeekBlock.js";

import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import isLeapYear from "dayjs/plugin/isLeapYear";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(isLeapYear);

// Let's keep it simple, 53 weeks a year
export default function WeekView({ birthday, expected }) {
  const list = [];
  const birthDate = new Date(birthday);
  const currentDate = new Date();
  const weeksBeforeBirth = dayjs(birthDate).isoWeek() - 1;
  const weeksBeforeCurrent =
    (currentDate.getFullYear() - birthDate.getFullYear()) * 53 +
    dayjs(currentDate).isoWeek() -
    1;
  const weeksTotal = expected * 53;

  function isExtraWeek(week) {
    return (
      week < weeksBeforeBirth ||
      (!yearOf(week).isLeapYear() && week % 53 === 52)
    );
  }

  function yearOf(week) {
    return dayjs(birthDate).add(Math.floor(week / 53), "year");
  }

  // Start from the week of birthday to the week of last day.
  // Paint the weeks before birthday to white.
  for (let i = 0; i < weeksTotal; i++) {
    list.push(
      <WeekBlock
        key={i}
        empty={isExtraWeek(i)}
        current={i === weeksBeforeCurrent && !isExtraWeek(i)}
        past={i < weeksBeforeCurrent && !isExtraWeek(i)}
        future={i > weeksBeforeCurrent && !isExtraWeek(i)}
      />
    );
  }

  // TODO When mouse over, show that year.
  return <div className="grid grid-flow-row grid-cols-53 gap-0.5">{list}</div>;
}
